import { styled } from "@mui/material/styles";
import { Button, Chip, Autocomplete, TextField } from "@mui/material";
import type { MccCode } from "./mccCodes";

export const ChipActive = styled(Chip)({
  "&.MuiChip-root": {
    backgroundColor: "transparent",
    color: "#4caf50",
    border: "1px solid #4caf50",
    borderRadius: "16px",
    fontSize: "13px",
    fontWeight: 400,
    letterSpacing: "0.16px",
    height: "24px",
  },

  "& .MuiChip-label": {
    padding: "0 6px",
    fontSize: "13px",
    fontWeight: 400,
    letterSpacing: "0.16px",
  },
});

export const ChipInactive = styled(Chip)({
  "&.MuiChip-root": {
    backgroundColor: "transparent",
    color: "#9e9e9e",
    border: "1px solid #9e9e9e",
    borderRadius: "16px",
    fontSize: "13px",
    fontWeight: 400,
    letterSpacing: "0.16px",
    height: "24px",
  },

  "& .MuiChip-label": {
    padding: "0 6px",
    fontSize: "13px",
    fontWeight: 400,
    letterSpacing: "0.16px",
  },
});

export const Container = styled("div")(({ theme }) => ({
  background: theme.palette.background.paper,
  borderRadius: "4px",
  padding: "16px",
  marginTop: "15px",
}));

export const Header = styled("div")({
  display: "flex",
  width: "100%",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "16px",
  padding: "8px 8px 8px 16px",
});

export const HeaderLeft = styled("div")({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "8px",
});

export const Content = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "16px",
  padding: "0px 8px",
});

export const FormRow = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "16px",
});

export const ButtonPrimary = styled(Button)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "auto",
  padding: "6px 16px",
  height: "36px",
  borderRadius: "40px",
  border: "solid 1px rgba(211, 49, 0, 0.5)",
  cursor: "pointer",
  color: "#d33100",
  gap: "6px",
  textTransform: "uppercase",
  fontSize: "14px",
  fontWeight: 500,

  "&:hover": {
    background: "rgba(211, 49, 0, 0.04)",
    borderColor: "rgba(211, 49, 0, 0.7)",
  },
});

export const ButtonSecondary = styled(Button)({
  display: "flex",
  background: "none",
  justifyContent: "center",
  alignItems: "center",
  width: "auto",
  padding: "6px 16px",
  height: "36px",
  borderRadius: "40px",
  border: "solid 1px rgba(211, 49, 0, 0.5)",
  cursor: "pointer",
  color: "#d33100",
  gap: "6px",
  textTransform: "uppercase",
  fontSize: "14px",
  fontWeight: 500,

  "&:hover": {
    background: "rgba(211, 49, 0, 0.04)",
    borderColor: "rgba(211, 49, 0, 0.7)",
  },
});

export const AutocompleteStyled = styled(
  Autocomplete<MccCode, false, false, false>,
)({
  width: 240,
});

export const TextFieldStyled = styled(TextField)<{ isEditing: boolean }>(
  ({ isEditing }) => ({
    "& .MuiOutlinedInput-notchedOutline": {
      borderStyle: isEditing ? "solid" : "dashed",
    },
  }),
);

export const EditMccButton = styled(ButtonSecondary)({
  width: 120,
});

export const SaveMccButton = styled(ButtonPrimary)({
  width: 130,
});

export const AddAcquirerButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 8px 16px !important;
  background: #d33100 !important;
  height: 40px;
  border-radius: 21px !important;
  border: solid 1px #d33100;
  cursor: pointer;
  color: #ffffff !important;
`;
